// extracted by mini-css-extract-plugin
export default {"Slider":"S4STcSvqkrY85BgBHxmA","Slider__input":"VkJHmJGJ05YwQ241Bsje","Slider__labels":"r9vxcxEh2hbpR0Ko5x4A","Slider__bubble":"VBYezzzF_Ya9iyqmTeCE"};